module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO23CalculadoraPresupuestob (54).57fbc05.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO23CalculadoraPresupuestob (54).mp4
// module id = 749
// module chunks = 1